import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Title from '../shop-the-look/partials/title'
import Description from '../shop-the-look/partials/description'
import 'swiper/css'

import PDComponent from '../../pd-component'

export const ShopTheLookGallery = ({regions, ...rest}) => {
    const {
        title,
        titleColor,
        titleSizeLargeDesktop,
        titleSizeMobile,
        titleSizeSmallDesktop,
        titleSizeTablet,
        titleTag,
        description,
        descriptionTag,
        descriptionFontFamily,
        descriptionColor,
        titleFontFamily,
        titleAlign,
        descriptionAlign,
        copyLocation
    } = rest

    const renderCopy = () => (
        <Box
            className="desktop-title-description"
            padding={copyLocation === 'below' ? '20px' : {base: '20px 15px', lg: '0 60px'}}
            maxW="1440px"
            mx="auto"
            display={title || description ? 'block' : 'none'}
        >
            {title && (
                <Title
                    title={title}
                    titleColor={titleColor}
                    titleSizeLargeDesktop={titleSizeLargeDesktop}
                    titleSizeMobile={titleSizeMobile}
                    titleSizeSmallDesktop={titleSizeSmallDesktop}
                    titleSizeTablet={titleSizeTablet}
                    titleFontFamily={titleFontFamily}
                    titleTag={titleTag}
                    titleAlign={titleAlign}
                />
            )}

            {description && (
                <Description
                    description={description}
                    descriptionColor={descriptionColor}
                    descriptionFontFamily={descriptionFontFamily}
                    descriptionTag={descriptionTag}
                    descriptionAlign={descriptionAlign}
                    marginBottom={'0'}
                />
            )}
        </Box>
    )
    return (
        <>
            {copyLocation === 'above' && renderCopy()}
            {regions?.map((region) => {
                const components = region?.components || []
                if (!components.length) return null

                const mainComponent = components[0]
                const gridComponents = components.slice(1, 5)
                return (
                    <>
                        <Box
                            maxW="1440px"
                            mx="auto"
                            key={region?.id}
                            overflow="hidden"
                            maxH={{base: '440px', md: '470px', lg: '800px', xl: '886px'}}
                            className="gallery-container"
                            sx={{
                                '.component-video': {
                                    aspectRatio: `344 / 416 !important`,
                                    width: '100%',
                                    height: 'auto',
                                    htmlWidth: 344,
                                    htmlHeight: 416
                                }
                            }}
                        >
                            <Box
                                overflowX={{base: 'auto', lg: 'visible'}}
                                sx={{
                                    WebkitOverflowScrolling: 'touch',
                                    '&::-webkit-scrollbar': {display: 'none'}
                                }}
                                className="gallery-container-items"
                            >
                                <Box
                                    display="grid"
                                    gridTemplateColumns="1fr 1fr"
                                    gap={2}
                                    minW={{base: '730px', lg: '100%'}}
                                    className="gallery-wrapper"
                                >
                                    {/* LEFT – MAIN IMAGE */}
                                    <Box position="relative" className="gallery-main">
                                        <PDComponent component={mainComponent} />
                                    </Box>

                                    {/* RIGHT – 2x2 GRID */}
                                    <Box
                                        display="grid"
                                        gridTemplateColumns="repeat(2, 1fr)"
                                        gap={2}
                                        className="gallery-grids-wrapper"
                                    >
                                        {gridComponents.map((component, index) => (
                                            <Box
                                                key={index}
                                                position="relative"
                                                className="gallery-grids"
                                            >
                                                <PDComponent component={component} />
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </>
                )
            })}
            {copyLocation === 'below' && renderCopy()}
        </>
    )
}

ShopTheLookGallery.propTypes = {
    regions: PropTypes.array
}

export default ShopTheLookGallery
